import { Close } from '@tcl-boron-icons/icons';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import LandingViewIcon from '../../../../assets/images/LandingViewIcon.svg';
import QNSLandingViewIcon from '../../../../assets/images/QNSLandingViewIcon.svg';
interface ReportLandingProps {
  isQNS: boolean;
  setShowLanding: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReportLandingView: React.FC<ReportLandingProps> = ({ isQNS, setShowLanding }) => {
  const handleClose = (): void => {
    sessionStorage.setItem('seenLanding', 'true');
    setShowLanding(false);
  };
  return (
    <>
      {!isQNS ? (
        <>
          <Grid
            padding={2}
            direction="row"
            position="relative"
            gap="8px"
            container
            justifyContent="center"
            alignItems="center"
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <Close onClick={handleClose} aria-label="close" style={{ textAlign: 'right', cursor: 'pointer' }} />
            </div>
            <Typography variant="h2" align="center" gutterBottom sx={{ width: '100%' }}>
              PGx Report is Available!
            </Typography>
          </Grid>
          <Typography variant="body1" align="center" gutterBottom>
            You and your clinician now have access to your PGx report.
          </Typography>
          <img src={LandingViewIcon} />
        </>
      ) : (
        <>
          <Grid
            padding={2}
            direction="row"
            position="relative"
            gap="8px"
            container
            justifyContent="center"
            alignItems="center"
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <Close onClick={handleClose} aria-label="close" style={{ textAlign: 'right', cursor: 'pointer' }} />
            </div>
            <Typography variant="h2" align="center" gutterBottom sx={{ width: '100%' }}>
              Incomplete PGx Report
            </Typography>
          </Grid>
          <img src={QNSLandingViewIcon} />
          <Typography variant="body1" gutterBottom>
            Unfortunately, we couldn’t process your sample because the recent sample provided for your Tempus test did
            not produce sufficient results in our lab. This happens sometimes, but it is not a cause for concern!
          </Typography>
          <Typography variant="body1" gutterBottom>
            No worries—<strong>we’re sending a new kit to your address.</strong> Just follow the instructions carefully!
          </Typography>
          <Typography variant="body1" gutterBottom>
            If you have any questions, please reach out to your clinician.
          </Typography>
        </>
      )}
    </>
  );
};

export default ReportLandingView;
